import React from "react";
import Button from "../../components/common/button";
import ViewItems from "./viewItems";

const FIELD_LABELS = {
  district: 'District',
  atpCode: 'Atp Code',
  name: 'Name',
  city: 'City',
  batchType: 'Batch Type'
}

const ViewSchool = (props) => {
  const {
    district,
    schoolProfile,
    gotoEditAction
  } = props;

  const viewSchool = (schoolProfile) ? {
    district: (district) ? district.name : '',
    atpCode: schoolProfile.atpCode,
    name: schoolProfile.name,
    city: schoolProfile.city,
    batchType: schoolProfile.batchType
  } : {
    district: 'none',
    atpCode: 0,
    name: 'N/A',
    city: 'N/A',
    batchType: 'M'
  };

  return (
    <div className='view-school-info'>
      <div className='view-header'>
        <div className='view-title'>School Info</div>
        <div className='view-buttons'>
        </div>
      </div>
      <div className='view-body'>
        <ViewItems labels={FIELD_LABELS} items={viewSchool}/>
      </div>
    </div>
  )
}

export default ViewSchool;